var React = require('react');

function ShoppingBag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z","key":0}),React.createElement("line",{"x1":"3","y1":"6","x2":"21","y2":"6","key":1}),React.createElement("path",{"d":"M16 10a4 4 0 0 1-8 0","key":2})]);
}

ShoppingBag.defaultProps = {"width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-shopping-bag"};

module.exports = ShoppingBag;

ShoppingBag.default = ShoppingBag;
